import type { SYSAction } from "../../../../../../../../_ovlclient/src"
import { FeatureInfo } from "../../../../../../../../_ovlclient/src/global/globalapi"
import {
  ScreenNavigateBack,
  ScreenNavigateTo,
} from "../../../../../../../../_ovlclient/src/library/screenapi"
import {
  TableGet,
  TableInit,
} from "../../../../../../../../_ovlclient/src/library/table/tableapi"
import type { OfferingTool } from "../../../../features/qutoffering/offering/state"
import { OpenTableUploadEdit, SelectOfferFile } from "../helpers"

const Reupload: SYSAction<{
  offeringToolState: OfferingTool
  file: File
}> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  //ScreenNavigateBack()
  let offeringToolState = value.offeringToolState
  offeringToolState.adminResumeDocEntry = undefined
  await SelectOfferFile(value.file, undefined)
  offeringToolState.imageLoaded = ""
  offeringToolState.detailsMaterialChanged = true
  offeringToolState.detailsTransportChanged = true
  offeringToolState.detailsCostChanged = true

  TableInit("QUTOfferingMaterial", { resetStrategy: { ClearData: true } })
  TableInit("QUTOfferingCosts", { resetStrategy: { ClearData: true } })
  TableInit("QUTOfferingTransport", { resetStrategy: { ClearData: true } })
}

export let actions = { Reupload }
